import { openBlock as M, createElementBlock as L, createElementVNode as e, defineComponent as f, ref as m, createVNode as _, toDisplayString as $, createTextVNode as T, unref as g, pushScopeId as x, popScopeId as z, getCurrentScope as q, onScopeDispose as K, computed as S, watch as B, watchEffect as t0, getCurrentInstance as e0, onMounted as a0, inject as Y, normalizeClass as y, renderSlot as h, createStaticVNode as c0, resolveComponent as O, withCtx as w, Transition as W, createCommentVNode as P, provide as s0, createBlock as n0 } from "vue";
const o0 = "data:image/svg+xml;base64,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";
const p = (t, a) => {
  const c = t.__vccOpts || t;
  for (const [s, n] of a)
    c[s] = n;
  return c;
}, i0 = {
  name: "CLAWordmark",
  components: {},
  props: {},
  setup() {
    return {
      wordmark: o0
    };
  }
}, r0 = {
  href: "https://cla.umn.edu",
  class: "wordmark-link"
}, l0 = ["src"];
function u0(t, a, c, s, n, i) {
  return M(), L("a", r0, [
    e("img", {
      src: s.wordmark,
      alt: "College of Liberal Arts"
    }, null, 8, l0)
  ]);
}
const R = /* @__PURE__ */ p(i0, [["render", u0], ["__scopeId", "data-v-419e7540"]]), k = (t) => (x("data-v-bfb11f2b"), t = t(), z(), t), d0 = { class: "app-footer" }, M0 = { class: "app-footer-container" }, L0 = { class: "footer-offset-container" }, _0 = { class: "footer-inner-container" }, h0 = { class: "footer-brand" }, p0 = { class: "link-wrapper" }, g0 = /* @__PURE__ */ k(() => /* @__PURE__ */ e("ul", { class: "footer-list" }, [
  /* @__PURE__ */ e("li", null, "LATIS"),
  /* @__PURE__ */ e("li", null, "110 Anderson Hall"),
  /* @__PURE__ */ e("li", null, "257 19th Ave S"),
  /* @__PURE__ */ e("li", null, "Minneapolis, MN, 55455")
], -1)), v0 = { class: "footer-connect" }, j0 = /* @__PURE__ */ k(() => /* @__PURE__ */ e("h2", null, "Connect", -1)), w0 = { class: "footer-list" }, y0 = ["href"], I0 = /* @__PURE__ */ k(() => /* @__PURE__ */ e("div", { class: "footer-text" }, null, -1)), N0 = /* @__PURE__ */ k(() => /* @__PURE__ */ e("div", { class: "footer-giving" }, [
  /* @__PURE__ */ e("h2", null, "Make a Gift"),
  /* @__PURE__ */ e("ul", { class: "footer-list" }, [
    /* @__PURE__ */ e("li", null, [
      /* @__PURE__ */ e("a", { href: "https://cla.umn.edu/give/" }, "Find information on ways to give to the College of Liberal Arts")
    ])
  ])
], -1)), f0 = { class: "university-footer" }, m0 = { class: "copyright-wrapper" }, C0 = { class: "accessibility-wrapper" }, A0 = ["href"], T0 = { class: "privacy-wrapper" }, S0 = ["href"], x0 = /* @__PURE__ */ f({
  __name: "AppFooter",
  props: {
    contact: { default: "latistecharch@umn.edu" },
    privacyUrl: { default: "https://twin-cities.umn.edu/privacy" }
  },
  setup(t) {
    const a = m(
      "https://oit-drupal-prd-web.oit.umn.edu/indexAccess.php?ref_url=" + encodeURI(window.location.href)
    );
    return (c, s) => (M(), L("footer", d0, [
      e("div", M0, [
        e("div", L0, [
          e("div", _0, [
            e("div", h0, [
              e("span", p0, [
                _(R)
              ]),
              g0
            ]),
            e("div", v0, [
              j0,
              e("ul", w0, [
                e("li", null, [
                  e("a", {
                    href: "mailto:" + c.contact
                  }, $(c.contact), 9, y0)
                ])
              ])
            ]),
            I0,
            N0
          ])
        ]),
        e("div", f0, [
          e("span", m0, " © " + $((/* @__PURE__ */ new Date()).getFullYear()) + " Regents of the University of Minnesota. All rights reserved. The University of Minnesota is an equal opportunity educator and employer.", 1),
          e("span", C0, [
            T("CLA is committed to making its digital resources accessible. "),
            e("a", { href: g(a) }, "Report Web Disability-Related Issue", 8, A0)
          ]),
          T(". "),
          e("span", T0, [
            e("a", { href: c.privacyUrl }, "Privacy", 8, S0)
          ])
        ])
      ])
    ]));
  }
});
const nt = /* @__PURE__ */ p(x0, [["__scopeId", "data-v-bfb11f2b"]]), G = {
  always: 0,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1440,
  // 90rem UMN header max width
  none: 1 / 0
}, D = Symbol(
  "menuBreakpoint"
);
function F(t) {
  return q() ? (K(t), !0) : !1;
}
function Q(t) {
  return typeof t == "function" ? t() : g(t);
}
const Z = typeof window < "u" && typeof document < "u", z0 = Object.prototype.toString, k0 = (t) => z0.call(t) === "[object Object]", U = () => {
}, D0 = /* @__PURE__ */ b0();
function b0() {
  var t;
  return Z && ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.userAgent) && /* @__PURE__ */ /iP(ad|hone|od)/.test(window.navigator.userAgent);
}
function O0(t, a) {
  var c;
  if (typeof t == "number")
    return t + a;
  const s = ((c = t.match(/^-?[0-9]+\.?[0-9]*/)) == null ? void 0 : c[0]) || "", n = t.slice(s.length), i = Number.parseFloat(s) + a;
  return Number.isNaN(i) ? t : i + n;
}
function A(t) {
  var a;
  const c = Q(t);
  return (a = c == null ? void 0 : c.$el) != null ? a : c;
}
const b = Z ? window : void 0;
function E(...t) {
  let a, c, s, n;
  if (typeof t[0] == "string" || Array.isArray(t[0]) ? ([c, s, n] = t, a = b) : [a, c, s, n] = t, !a)
    return U;
  Array.isArray(c) || (c = [c]), Array.isArray(s) || (s = [s]);
  const i = [], u = () => {
    i.forEach((I) => I()), i.length = 0;
  }, o = (I, N, l, d) => (I.addEventListener(N, l, d), () => I.removeEventListener(N, l, d)), r = B(
    () => [A(a), Q(n)],
    ([I, N]) => {
      if (u(), !I)
        return;
      const l = k0(N) ? { ...N } : N;
      i.push(
        ...c.flatMap((d) => s.map((j) => o(I, d, j, l)))
      );
    },
    { immediate: !0, flush: "post" }
  ), v = () => {
    r(), u();
  };
  return F(v), v;
}
let V = !1;
function E0(t, a, c = {}) {
  const { window: s = b, ignore: n = [], capture: i = !0, detectIframe: u = !1 } = c;
  if (!s)
    return;
  D0 && !V && (V = !0, Array.from(s.document.body.children).forEach((l) => l.addEventListener("click", U)), s.document.documentElement.addEventListener("click", U));
  let o = !0;
  const r = (l) => n.some((d) => {
    if (typeof d == "string")
      return Array.from(s.document.querySelectorAll(d)).some((j) => j === l.target || l.composedPath().includes(j));
    {
      const j = A(d);
      return j && (l.target === j || l.composedPath().includes(j));
    }
  }), I = [
    E(s, "click", (l) => {
      const d = A(t);
      if (!(!d || d === l.target || l.composedPath().includes(d))) {
        if (l.detail === 0 && (o = !r(l)), !o) {
          o = !0;
          return;
        }
        a(l);
      }
    }, { passive: !0, capture: i }),
    E(s, "pointerdown", (l) => {
      const d = A(t);
      d && (o = !l.composedPath().includes(d) && !r(l));
    }, { passive: !0 }),
    u && E(s, "blur", (l) => {
      setTimeout(() => {
        var d;
        const j = A(t);
        ((d = s.document.activeElement) == null ? void 0 : d.tagName) === "IFRAME" && !(j != null && j.contains(s.document.activeElement)) && a(l);
      }, 0);
    })
  ].filter(Boolean);
  return () => I.forEach((l) => l());
}
function $0() {
  const t = m(!1);
  return e0() && a0(() => {
    t.value = !0;
  }), t;
}
function U0(t) {
  const a = $0();
  return S(() => (a.value, !!t()));
}
function C(t, a = {}) {
  const { window: c = b } = a, s = U0(() => c && "matchMedia" in c && typeof c.matchMedia == "function");
  let n;
  const i = m(!1), u = (v) => {
    i.value = v.matches;
  }, o = () => {
    n && ("removeEventListener" in n ? n.removeEventListener("change", u) : n.removeListener(u));
  }, r = t0(() => {
    s.value && (o(), n = c.matchMedia(Q(t)), "addEventListener" in n ? n.addEventListener("change", u) : n.addListener(u), i.value = n.matches);
  });
  return F(() => {
    r(), o(), n = void 0;
  }), i;
}
function X(t, a = {}) {
  function c(o, r) {
    let v = t[o];
    return r != null && (v = O0(v, r)), typeof v == "number" && (v = `${v}px`), v;
  }
  const { window: s = b } = a;
  function n(o) {
    return s ? s.matchMedia(o).matches : !1;
  }
  const i = (o) => C(`(min-width: ${c(o)})`, a), u = Object.keys(t).reduce((o, r) => (Object.defineProperty(o, r, {
    get: () => i(r),
    enumerable: !0,
    configurable: !0
  }), o), {});
  return Object.assign(u, {
    greater(o) {
      return C(`(min-width: ${c(o, 0.1)})`, a);
    },
    greaterOrEqual: i,
    smaller(o) {
      return C(`(max-width: ${c(o, -0.1)})`, a);
    },
    smallerOrEqual(o) {
      return C(`(max-width: ${c(o)})`, a);
    },
    between(o, r) {
      return C(`(min-width: ${c(o)}) and (max-width: ${c(r, -0.1)})`, a);
    },
    isGreater(o) {
      return n(`(min-width: ${c(o, 0.1)})`);
    },
    isGreaterOrEqual(o) {
      return n(`(min-width: ${c(o)})`);
    },
    isSmaller(o) {
      return n(`(max-width: ${c(o, -0.1)})`);
    },
    isSmallerOrEqual(o) {
      return n(`(max-width: ${c(o)})`);
    },
    isInBetween(o, r) {
      return n(`(min-width: ${c(o)}) and (max-width: ${c(r, -0.1)})`);
    },
    current() {
      const o = Object.keys(t).map((r) => [r, i(r)]);
      return S(() => o.filter(([, r]) => r.value).map(([r]) => r));
    }
  });
}
const H = (t) => {
  const a = X(G);
  return { atBreakpoint: S(() => a.isGreaterOrEqual(t)) };
}, Y0 = { class: "tw-flex tw-max-w-[90em] tw-w-full tw-mx-auto tw-justify-between tw-items-center tw-p-4" }, Q0 = { class: "branding-block tw-flex tw-flex-col tw-gap-2" }, H0 = { class: "link-wrapper" }, V0 = { class: "tw-text-2xl tw-leading-none tw-font-semibold tw-text-umn-maroon tw-m-0" }, B0 = /* @__PURE__ */ f({
  __name: "CollegeHeader",
  props: {
    isMenuOpen: { type: Boolean, default: !1 },
    href: { default: "/" }
  },
  emits: ["clickMenu"],
  setup(t) {
    const { atBreakpoint: a } = H("always"), c = Y(D, a);
    return (s, n) => (M(), L("div", {
      class: y(["college-header", [g(c) ? "tw-bg-white" : "tw-bg-umn-neutral-100"]])
    }, [
      e("div", Y0, [
        e("div", Q0, [
          e("span", H0, [
            _(R)
          ]),
          e("h1", V0, [
            h(s.$slots, "app-link")
          ])
        ]),
        h(s.$slots, "right")
      ])
    ], 2));
  }
});
const W0 = /* @__PURE__ */ p(B0, [["__scopeId", "data-v-e26123d2"]]);
const P0 = {
  name: "UniversityHeaderButtonContainer",
  props: {},
  setup() {
  }
}, R0 = (t) => (x("data-v-f08d3c8c"), t = t(), z(), t), G0 = {
  role: "navigation",
  class: "university-header-nav"
}, F0 = /* @__PURE__ */ R0(() => /* @__PURE__ */ e("h2", { class: "visually-hidden" }, "University Header Menu", -1)), Z0 = { class: "university-header-button-container" };
function X0(t, a, c, s, n, i) {
  return M(), L("nav", G0, [
    F0,
    e("ul", Z0, [
      h(t.$slots, "default", {}, void 0, !0)
    ])
  ]);
}
const J0 = /* @__PURE__ */ p(P0, [["render", X0], ["__scopeId", "data-v-f08d3c8c"]]);
const q0 = {
  name: "UniversityHeaderButton",
  props: {
    linkTarget: {
      type: String,
      required: !0
    },
    showBorder: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    return {
      classes: S(() => ({
        "bordered-button": t.showBorder === !0
      }))
    };
  }
}, K0 = { class: "university-header-button" }, t1 = ["href"], e1 = { class: "link-inner" };
function a1(t, a, c, s, n, i) {
  return M(), L("li", K0, [
    e("a", {
      href: c.linkTarget,
      class: y(s.classes)
    }, [
      e("span", e1, [
        h(t.$slots, "default", {}, void 0, !0)
      ])
    ], 10, t1)
  ]);
}
const c1 = /* @__PURE__ */ p(q0, [["render", a1], ["__scopeId", "data-v-67c04cd1"]]);
const s1 = {
  name: "UMNWordmark",
  components: {},
  props: {},
  setup() {
  }
}, n1 = {
  href: "https://umn.edu",
  class: "wordmark-link"
}, o1 = {
  class: "umn-wordmark",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1",
  id: "wordmark-full",
  x: "0px",
  y: "0px",
  viewBox: "0 0 285.87 37.96",
  style: { "enable-background": "new 0 0 285.87 37.96" },
  "xml:space": "preserve"
}, i1 = /* @__PURE__ */ c0('<title data-v-8ac18265>UMN Wordmark</title><g class="wordmark block_m" data-v-8ac18265><path class="fill__maroon" d="M54.65,29.11L44.43,12.12h2.82V3.26H30.24v8.85h2.82l-3.91,6.49l-3.9-6.49h2.81V3.26H11.05v8.85h2.81    L3.65,29.11H0v8.85h17.35v-8.85h-3.12l5.32-8.85l2.06,3.43h-1.98v8.85h19.02v-8.85h-1.98l2.07-3.43l5.32,8.85h-3.11v8.85H58.3    v-8.85H54.65z" data-v-8ac18265></path></g><g class="wordmark u-of-m" data-v-8ac18265><path class="fill__dark-gray" d="M276.46,3.48l0.08,2.72h-0.36c-0.33-1.75-0.75-2.03-3.05-2.03v8.13c0,0.95,0.49,1.37,1.37,1.37v0.38h-4.26    v-0.38c0.89,0,1.37-0.42,1.37-1.37V4.17c-2.3,0-2.72,0.29-3.05,2.03h-0.35l0.08-2.72H276.46z" data-v-8ac18265></path><path class="fill__dark-gray" d="M262.33,3.28c-2.61,0-4.72,2.15-4.72,5.48s2.11,5.48,4.72,5.48s4.72-2.14,4.72-5.48S264.94,3.28,262.33,3.28z     M262.33,13.62c-1.98,0-3.11-1.9-3.11-4.86c0-2.95,1.13-4.86,3.11-4.86c1.98,0,3.11,1.9,3.11,4.86    C265.45,11.71,264.32,13.62,262.33,13.62z" data-v-8ac18265></path><path class="fill__dark-gray" d="M284.71,12.76c-0.19-0.49-3.74-9.42-3.74-9.42h-0.36c0,0-3.13,8.19-3.52,9.15c-0.39,0.96-0.85,1.2-1.22,1.2    v0.38h2.88v-0.38c-0.42,0-0.9-0.3-0.9-0.76c0-0.14,0.01-0.3,0.05-0.4c0.03-0.08,0.33-0.88,0.7-1.91h3.66    c0.37,1.02,0.66,1.8,0.67,1.84c0.05,0.14,0.11,0.33,0.11,0.47c0,0.41-0.33,0.76-0.95,0.76v0.38h3.71v-0.38    C285.37,13.68,284.9,13.25,284.71,12.76z M278.89,9.87c0.72-1.94,1.56-4.23,1.56-4.23s0.85,2.3,1.55,4.23H278.89z" data-v-8ac18265></path><path class="fill__dark-gray" d="M247.09,11.31c-0.47,1.1-1.07,2.06-2.75,2.06c-0.36,0-1.1,0-1.68,0c-0.61,0-0.88-0.21-0.88-0.72    c0-0.2,0-1.94,0-3.77c0.41,0,1.67,0,2.28,0c0.88,0,1.35,0.5,1.48,1.43h0.36V6.67h-0.38c-0.05,1.02-0.58,1.51-1.37,1.51    c-0.68,0-1.98,0-2.36,0c0-1.74,0-3.37,0-3.54c0-0.39,0.25-0.47,0.58-0.47c0.33,0,1.07,0,2.03,0c1.26,0,1.7,0.52,1.98,1.7h0.36    l-0.08-2.39h-7.61v0.39c0.89,0,1.29,0.42,1.29,1.37v7.06c0,0.95-0.41,1.37-1.29,1.37v0.38h7.8l0.68-2.75H247.09z" data-v-8ac18265></path><path class="fill__dark-gray" d="M255.14,3.27l0.3,3.49h-0.39c-0.52-1.72-1.4-2.78-2.66-2.78c-0.91,0-1.43,0.61-1.43,1.43    c0,0.93,0.69,1.48,1.54,2.06c0.85,0.58,1.43,0.96,1.7,1.15c0.79,0.55,1.54,1.54,1.54,2.67c0,1.72-1.29,2.99-2.99,2.99    c-1.04,0-1.7-0.52-2.23-0.52c-0.29,0-0.43,0.29-0.49,0.52h-0.36l-0.44-3.52h0.39c0.64,1.8,1.59,2.86,2.91,2.86    c0.99,0,1.73-0.68,1.73-1.78c0-1-0.53-1.48-1.15-1.92c-0.7-0.49-1.56-1.1-2.09-1.46c-0.82-0.56-1.32-1.31-1.32-2.53    c0-1.46,0.96-2.66,2.61-2.66c0.71,0,1.51,0.47,1.95,0.47c0.33,0,0.47-0.22,0.49-0.47H255.14z" data-v-8ac18265></path><path class="fill__dark-gray" d="M234.12,3.48v0.39c0.82,0,1.32,0.63,1.32,1.59c0,0.65,0,3.68,0,5.56l-5.49-7.54h-2.39v0.39    c0.47,0,0.85,0.22,1.04,0.47c0.02,0.03,0.13,0.18,0.3,0.41c0,1.15,0,6.15,0,7.1c0,1.21-0.41,1.84-1.37,1.84v0.38h3.38v-0.38    c-0.83,0-1.32-0.55-1.32-1.51c0-0.78,0-4.94,0-6.49c2,2.7,6.32,8.56,6.32,8.56h0.22c0,0,0-7.45,0-8.52c0-1.35,0.55-1.84,1.37-1.84    V3.48H234.12z" data-v-8ac18265></path><path class="fill__dark-gray" d="M222.39,3.48v0.39c0.83,0,1.32,0.63,1.32,1.59c0,0.65,0,3.68,0,5.56l-5.49-7.54h-2.39v0.39    c0.47,0,0.85,0.22,1.04,0.47c0.02,0.03,0.13,0.18,0.3,0.41c0,1.15,0,6.15,0,7.1c0,1.21-0.41,1.84-1.37,1.84v0.38h3.38v-0.38    c-0.83,0-1.32-0.55-1.32-1.51c0-0.78,0-4.94,0-6.49c2,2.7,6.32,8.56,6.32,8.56h0.22c0,0,0-7.45,0-8.52c0-1.35,0.55-1.84,1.37-1.84    V3.48H222.39z" data-v-8ac18265></path><path class="fill__dark-gray" d="M208.21,0.44V0.05h-3.27l-4.26,11.43L196.4,0.05h-3.33v0.39c1.4,0,1.79,0.77,1.79,2.14s0,8.32,0,8.6    c0,1.99-0.56,2.5-1.81,2.5v0.38h4.31v-0.38c-1.21,0-1.79-0.52-1.79-2.5c0-1.98,0-8.98,0-8.98l4.45,11.9h0.41l4.54-12.11    c0,0,0,8.85,0,9.2c0,1.99-0.45,2.5-1.71,2.5v0.38h4.94v-0.38c-1.21,0-1.67-0.52-1.67-2.5c0-0.77,0-7.64,0-8.79    C206.54,0.79,207.39,0.44,208.21,0.44z" data-v-8ac18265></path><path class="fill__dark-gray" d="M212.25,5.24c0-0.95,0.49-1.37,1.37-1.37V3.48h-4.26v0.39c0.89,0,1.37,0.42,1.37,1.37v7.06    c0,0.95-0.49,1.37-1.37,1.37v0.38h4.26v-0.38c-0.89,0-1.37-0.42-1.37-1.37V5.24z" data-v-8ac18265></path><path class="fill__dark-gray" d="M173.25,3.29c-2.61,0-4.72,2.15-4.72,5.48c0,3.33,2.12,5.48,4.72,5.48c2.61,0,4.72-2.14,4.72-5.48    C177.98,5.44,175.86,3.29,173.25,3.29z M173.25,13.63c-1.98,0-3.11-1.9-3.11-4.86c0-2.96,1.13-4.86,3.11-4.86    c1.98,0,3.11,1.9,3.11,4.86C176.37,11.73,175.23,13.63,173.25,13.63z" data-v-8ac18265></path><path class="fill__dark-gray" d="M187.14,3.48h-7.69v0.39c0.89,0,1.29,0.42,1.29,1.37v7.06c0,0.95-0.4,1.37-1.29,1.37v0.38h4.09v-0.38    c-0.85,0-1.35-0.41-1.35-1.37c0-0.19,0-1.75,0-3.41c0.4,0,1.59,0,2.2,0c0.88,0,1.35,0.5,1.49,1.43h0.36V6.67h-0.38    c-0.05,1.02-0.58,1.51-1.37,1.51c-0.67,0-1.91,0-2.28,0c0-1.72,0-3.36,0-3.54c0-0.39,0.25-0.47,0.58-0.47c0.33,0,1.15,0,2.12,0    c1.26,0,1.7,0.52,1.98,1.7h0.36L187.14,3.48z" data-v-8ac18265></path><path class="fill__dark-gray" d="M151.82,3.5l0.08,2.72h-0.36c-0.33-1.74-0.76-2.03-3.05-2.03v8.13c0,0.95,0.49,1.37,1.37,1.37v0.38h-4.26    v-0.38c0.89,0,1.37-0.42,1.37-1.37V4.19c-2.29,0-2.72,0.29-3.05,2.03h-0.36l0.08-2.72H151.82z" data-v-8ac18265></path><path class="fill__dark-gray" d="M159.98,3.88V3.5h3.24v0.38c-0.47,0-1.2,0.51-1.51,1.02c-0.34,0.56-2.61,4.34-2.61,4.34v3.08    c0,1.03,0.38,1.37,1.48,1.37v0.38h-4.48v-0.38c1.11,0,1.48-0.35,1.48-1.37V9.41c0,0-2.5-3.99-2.8-4.48    c-0.3-0.49-0.91-1.04-1.48-1.04V3.5h4.18v0.38c-0.58,0-0.99,0.26-0.99,0.56c0,0.2,0.1,0.43,0.17,0.55    c0.07,0.12,2.12,3.49,2.12,3.49s2.03-3.53,2.09-3.62c0.06-0.1,0.08-0.22,0.08-0.34C160.94,4.23,160.78,3.88,159.98,3.88z" data-v-8ac18265></path><path class="fill__dark-gray" d="M134.95,3.27l0.3,3.49h-0.38c-0.52-1.72-1.4-2.78-2.66-2.78c-0.91,0-1.43,0.61-1.43,1.43    c0,0.93,0.69,1.48,1.54,2.06c0.85,0.58,1.43,0.96,1.7,1.15c0.79,0.55,1.54,1.54,1.54,2.67c0,1.72-1.29,2.99-2.99,2.99    c-1.05,0-1.7-0.52-2.23-0.52c-0.29,0-0.42,0.29-0.49,0.52h-0.36l-0.44-3.52h0.39c0.64,1.8,1.59,2.86,2.91,2.86    c0.99,0,1.73-0.68,1.73-1.78c0-1-0.53-1.48-1.15-1.92c-0.7-0.49-1.56-1.1-2.09-1.46c-0.82-0.56-1.32-1.31-1.32-2.53    c0-1.46,0.96-2.66,2.61-2.66c0.71,0,1.51,0.47,1.95,0.47c0.33,0,0.47-0.22,0.49-0.47H134.95z" data-v-8ac18265></path><path class="fill__dark-gray" d="M140.78,5.26c0-0.95,0.49-1.37,1.37-1.37V3.5h-4.26v0.38c0.89,0,1.37,0.42,1.37,1.37v7.06    c0,0.95-0.49,1.37-1.37,1.37v0.38h4.26v-0.38c-0.89,0-1.37-0.42-1.37-1.37V5.26z" data-v-8ac18265></path><path class="fill__dark-gray" d="M116.55,11.31c-0.47,1.1-1.07,2.06-2.75,2.06c-0.36,0-1.1,0-1.68,0c-0.61,0-0.88-0.21-0.88-0.72    c0-0.2,0-1.94,0-3.77c0.41,0,1.67,0,2.28,0c0.88,0,1.35,0.5,1.48,1.43h0.36V6.67h-0.38c-0.06,1.02-0.58,1.51-1.37,1.51    c-0.68,0-1.98,0-2.36,0c0-1.74,0-3.37,0-3.54c0-0.39,0.25-0.47,0.58-0.47c0.33,0,1.07,0,2.03,0c1.26,0,1.7,0.52,1.98,1.7h0.36    l-0.08-2.39h-7.61v0.39c0.89,0,1.29,0.42,1.29,1.37v7.06c0,0.95-0.4,1.37-1.29,1.37v0.38h7.8l0.69-2.75H116.55z" data-v-8ac18265></path><path class="fill__dark-gray" d="M126.6,13.21c-0.25-0.29-2.59-3.51-3.11-4.23c1.89-0.4,2.56-1.37,2.56-2.75c0-1.65-1.24-2.75-3.49-2.75    c-0.27,0-4.23,0-4.23,0v0.39c0.89,0,1.29,0.42,1.29,1.37v7.06c0,0.95-0.41,1.37-1.29,1.37v0.38h4.09v-0.38    c-0.89,0-1.29-0.42-1.29-1.37V9.2c0.28,0,0.55-0.01,0.8-0.02l3.43,4.89h2.31v-0.33C127.29,13.73,126.88,13.54,126.6,13.21z     M121.13,8.57V4.99c0-0.73,0.15-0.91,0.96-0.91c1.79,0,2.44,0.88,2.44,2.2c0,1.62-1.23,2.28-3.05,2.28    C121.35,8.57,121.24,8.57,121.13,8.57z" data-v-8ac18265></path><path class="fill__dark-gray" d="M94.13,5.24c0-0.95,0.48-1.37,1.37-1.37V3.48h-4.26v0.39c0.89,0,1.37,0.42,1.37,1.37v7.06    c0,0.95-0.49,1.37-1.37,1.37v0.38h4.26v-0.38c-0.89,0-1.37-0.42-1.37-1.37V5.24z" data-v-8ac18265></path><path class="fill__dark-gray" d="M101.11,3.87V3.48h-3.87v0.39c0.47,0,0.96,0.3,1.29,1.1c0.33,0.79,3.82,9.26,3.82,9.26h0.25    c0,0,3.05-8.52,3.33-9.26c0.27-0.74,0.74-1.1,1.18-1.1V3.48h-2.99v0.39c0.66,0,1.02,0.36,1.02,0.82c0,0.14-0.04,0.29-0.08,0.41    c-0.06,0.16-2.22,6.24-2.22,6.24s-2.56-6.14-2.63-6.32c-0.06-0.14-0.09-0.32-0.09-0.48C100.09,4.12,100.44,3.87,101.11,3.87z" data-v-8ac18265></path><path class="fill__dark-gray" d="M65.61,0.44c1.15,0,1.76,0.58,1.76,2.22c0,1.65,0,3.82,0,6.54c0,3.3,1.81,5.06,4.97,5.06    c2.72,0,4.81-1.65,4.81-4.84c0-2.94,0-6.04,0-7.14c0-1.1,0.33-1.84,1.65-1.84V0.05h-4.18v0.39c1.18,0,1.67,0.52,1.7,1.95    c0.03,1.43,0.11,5.17,0.11,7.39c0,2.22-1.59,3.62-3.76,3.62c-2.09,0-3.74-1.24-3.74-3.85s0-6.16,0-7.31    c0-1.08,0.41-1.81,1.65-1.81V0.05h-4.97V0.44z" data-v-8ac18265></path><path class="fill__dark-gray" d="M85.67,3.48v0.39c0.82,0,1.32,0.63,1.32,1.59c0,0.65,0,3.68,0,5.56l-5.49-7.54H79.1v0.39    c0.47,0,0.85,0.22,1.05,0.47c0.02,0.03,0.13,0.18,0.3,0.41c0,1.15,0,6.15,0,7.1c0,1.21-0.41,1.84-1.37,1.84v0.38h3.38v-0.38    c-0.82,0-1.32-0.55-1.32-1.51c0-0.78,0-4.94,0-6.49c2,2.7,6.32,8.56,6.32,8.56h0.22c0,0,0-7.45,0-8.52c0-1.35,0.55-1.84,1.37-1.84    V3.48H85.67z" data-v-8ac18265></path></g><g class="wordmark d-2-d" data-v-8ac18265><path class="fill__maroon" d="M93.98,24.97h3.93c3.93,0,6.73,2.61,6.73,6.39c0,3.78-2.78,6.39-6.73,6.39h-3.93V24.97z M97.78,35.44      c2.84,0,4.13-1.69,4.13-4.08c0-2.38-1.3-4.08-4.13-4.08h-1.16v8.15H97.78z" data-v-8ac18265></path><path class="fill__maroon" d="M107.01,29.75h2.54l-0.04,1.45c0.58-1.32,1.52-1.62,2.35-1.62c0.53,0,0.92,0.15,1.24,0.32l-0.81,2.31      c-0.32-0.15-0.62-0.24-0.98-0.24c-1.15,0-1.77,0.53-1.77,2.24v3.55h-2.54V29.75z" data-v-8ac18265></path><path class="fill__maroon" d="M115.07,26.82c0-0.92,0.75-1.58,1.62-1.58c0.86,0,1.6,0.66,1.6,1.58c0,0.94-0.73,1.6-1.6,1.6      C115.82,28.41,115.07,27.75,115.07,26.82z M115.41,29.75h2.54v8h-2.54V29.75z" data-v-8ac18265></path><path class="fill__maroon" d="M120.14,29.75h2.8l1.13,2.39c0.38,0.81,0.66,2.12,0.66,2.12s0.26-1.31,0.62-2.12l1.09-2.39h2.57l-4.28,8.17      h-0.24L120.14,29.75z" data-v-8ac18265></path><path class="fill__maroon" d="M135.03,35.82c0.92,0,1.62-0.36,2.01-0.64l1.45,1.56c-0.77,0.68-1.75,1.18-3.42,1.18      c-2.86,0-4.7-1.73-4.7-4.19c0-2.42,1.94-4.15,4.42-4.15c2.87,0,4.44,2.14,4.25,4.94h-6.07      C133.21,35.35,133.88,35.82,135.03,35.82z M136.48,33.05c-0.11-0.88-0.68-1.41-1.67-1.41c-1,0-1.67,0.45-1.88,1.41H136.48z" data-v-8ac18265></path><path class="fill__maroon" d="M141.7,29.75h2.54l-0.06,1.31c0.49-0.96,1.43-1.48,2.54-1.48c1.75,0,3.01,1.28,3.01,3.55v4.62h-2.54V33.3      c0-0.9-0.43-1.41-1.33-1.41c-1.01,0-1.62,0.56-1.62,1.58v4.29h-2.54V29.75z" data-v-8ac18265></path><path class="fill__maroon" d="M158.46,34.75v-2.9h-1.18v-2.1h1.18v-4.17h2.52v4.17h2.05v2.1h-2.05v2.97c0,0.81,0.26,0.97,0.66,0.97      c0.41,0,0.71-0.22,0.88-0.34l0.96,1.77c-0.4,0.32-1.07,0.73-2.24,0.73C159.62,37.96,158.46,37.15,158.46,34.75z" data-v-8ac18265></path><path class="fill__maroon" d="M165.34,33.77c0-2.44,1.94-4.19,4.42-4.19c2.48,0,4.4,1.75,4.4,4.19c0,2.43-1.92,4.15-4.4,4.15      C167.27,37.92,165.34,36.19,165.34,33.77z M171.56,33.77c0-1.2-0.67-2.01-1.8-2.01c-1.13,0-1.82,0.81-1.82,2.01      c0,1.18,0.69,2.01,1.82,2.01C170.88,35.78,171.56,34.95,171.56,33.77z" data-v-8ac18265></path><path class="fill__maroon" d="M182.23,24.97h3.93c3.93,0,6.73,2.61,6.73,6.39c0,3.78-2.78,6.39-6.73,6.39h-3.93V24.97z M186.03,35.44      c2.84,0,4.13-1.69,4.13-4.08c0-2.38-1.3-4.08-4.13-4.08h-1.16v8.15H186.03z" data-v-8ac18265></path><path class="fill__maroon" d="M195.46,26.82c0-0.92,0.75-1.58,1.61-1.58c0.86,0,1.59,0.66,1.59,1.58c0,0.94-0.73,1.6-1.59,1.6      C196.21,28.41,195.46,27.75,195.46,26.82z M195.8,29.75h2.54v8h-2.54V29.75z" data-v-8ac18265></path><path class="fill__maroon" d="M200.78,36.4l1.48-1.31c0.55,0.53,1.24,0.84,1.99,0.84c0.83,0,1.09-0.15,1.09-0.49      c0-0.43-0.51-0.43-1.81-0.77c-1.09-0.28-2.31-0.88-2.31-2.55c0-1.8,1.39-2.54,3.1-2.54c1.31,0,2.26,0.43,2.91,1.11l-1.35,1.45      c-0.38-0.32-0.94-0.6-1.54-0.6c-0.58,0-0.86,0.15-0.86,0.47c0,0.45,0.51,0.51,1.6,0.75c1.16,0.27,2.63,0.81,2.63,2.5      c0,1.47-0.77,2.67-3.29,2.67C202.56,37.92,201.47,37.22,200.78,36.4z" data-v-8ac18265></path><path class="fill__maroon" d="M209.93,33.73c0-2.42,1.88-4.15,4.38-4.15c1.6,0,2.55,0.58,3.36,1.6l-1.8,1.47      c-0.3-0.49-0.92-0.85-1.56-0.85c-1.14,0-1.79,0.81-1.79,1.94c0,1.16,0.64,1.99,1.79,1.99c0.81,0,1.24-0.37,1.62-0.75l1.71,1.5      c-0.79,0.88-1.73,1.45-3.33,1.45C211.81,37.92,209.93,36.19,209.93,33.73z" data-v-8ac18265></path><path class="fill__maroon" d="M219.64,33.77c0-2.44,1.94-4.19,4.42-4.19c2.48,0,4.4,1.75,4.4,4.19c0,2.43-1.92,4.15-4.4,4.15      C221.58,37.92,219.64,36.19,219.64,33.77z M225.87,33.77c0-1.2-0.68-2.01-1.8-2.01c-1.13,0-1.82,0.81-1.82,2.01      c0,1.18,0.7,2.01,1.82,2.01C225.19,35.78,225.87,34.95,225.87,33.77z" data-v-8ac18265></path><path class="fill__maroon" d="M229.81,29.75h2.8l1.13,2.39c0.38,0.81,0.66,2.12,0.66,2.12s0.26-1.31,0.62-2.12l1.09-2.39h2.57l-4.29,8.17      h-0.24L229.81,29.75z" data-v-8ac18265></path><path class="fill__maroon" d="M244.7,35.82c0.92,0,1.62-0.36,2.01-0.64l1.45,1.56c-0.77,0.68-1.75,1.18-3.42,1.18      c-2.86,0-4.7-1.73-4.7-4.19c0-2.42,1.94-4.15,4.42-4.15c2.88,0,4.44,2.14,4.25,4.94h-6.07      C242.87,35.35,243.55,35.82,244.7,35.82z M246.14,33.05c-0.11-0.88-0.68-1.41-1.67-1.41c-1,0-1.67,0.45-1.88,1.41H246.14z" data-v-8ac18265></path><path class="fill__maroon" d="M251.37,29.75h2.54l-0.04,1.45c0.58-1.32,1.52-1.62,2.35-1.62c0.53,0,0.92,0.15,1.24,0.32l-0.81,2.31      c-0.32-0.15-0.62-0.24-0.97-0.24c-1.15,0-1.77,0.53-1.77,2.24v3.55h-2.54V29.75z" data-v-8ac18265></path><path class="fill__maroon" d="M262.5,28.41c0.28,0.11,0.52,0.27,0.72,0.47c0.2,0.2,0.36,0.42,0.48,0.66c0.15,0.31,0.23,0.65,0.23,1.01     c0,0.4-0.1,0.79-0.3,1.15c-0.2,0.37-0.49,0.65-0.85,0.85c-0.36,0.2-0.74,0.3-1.14,0.3c-0.39,0-0.77-0.1-1.13-0.3     c-0.36-0.2-0.64-0.49-0.85-0.85c-0.2-0.36-0.3-0.75-0.3-1.15c0-0.34,0.07-0.66,0.2-0.94c0.13-0.28,0.3-0.52,0.49-0.71     c0.2-0.19,0.41-0.34,0.65-0.45c0.31-0.14,0.62-0.21,0.94-0.21C261.94,28.25,262.22,28.3,262.5,28.41z M264.12,29.43     c-0.12-0.28-0.3-0.53-0.53-0.77c-0.23-0.24-0.51-0.43-0.84-0.58c-0.33-0.16-0.7-0.23-1.1-0.23c-0.41,0-0.81,0.09-1.18,0.27     c-0.27,0.13-0.52,0.31-0.75,0.53c-0.23,0.23-0.41,0.5-0.56,0.84c-0.15,0.33-0.22,0.69-0.22,1.07c0,0.47,0.12,0.92,0.36,1.35     c0.24,0.43,0.57,0.76,1,1c0.43,0.24,0.88,0.36,1.35,0.36c0.42,0,0.81-0.09,1.18-0.27c0.29-0.14,0.55-0.33,0.78-0.57     c0.24-0.24,0.42-0.53,0.55-0.86c0.13-0.33,0.19-0.67,0.19-1.01C264.36,30.17,264.28,29.79,264.12,29.43z M261.56,30.94     c0.17,0,0.3,0.02,0.39,0.07c0.09,0.05,0.15,0.11,0.19,0.19c0.04,0.08,0.06,0.21,0.08,0.39c0.01,0.25,0.03,0.4,0.05,0.45h0.64     c-0.03-0.08-0.04-0.21-0.05-0.4c0-0.18-0.01-0.31-0.03-0.38c-0.03-0.12-0.07-0.22-0.12-0.3c-0.06-0.08-0.12-0.14-0.21-0.19     c-0.08-0.05-0.19-0.08-0.33-0.11c0.16-0.02,0.27-0.04,0.33-0.08c0.12-0.06,0.22-0.15,0.29-0.26c0.07-0.12,0.11-0.25,0.11-0.4     c0-0.15-0.03-0.29-0.1-0.41c-0.07-0.12-0.16-0.21-0.26-0.28c-0.11-0.07-0.25-0.12-0.42-0.15c-0.12-0.02-0.3-0.03-0.53-0.03h-1.07     v2.99h0.67v-1.1H261.56z M261.91,29.56c0.1,0.03,0.18,0.08,0.24,0.15c0.06,0.07,0.09,0.16,0.09,0.26c0,0.1-0.02,0.18-0.08,0.26     c-0.05,0.08-0.12,0.14-0.22,0.17c-0.1,0.04-0.21,0.06-0.32,0.06h-0.44v-0.95h0.44C261.71,29.51,261.81,29.53,261.91,29.56z" data-v-8ac18265></path></g>', 4), r1 = [
  i1
];
function l1(t, a, c, s, n, i) {
  return M(), L("a", n1, [
    (M(), L("svg", o1, r1))
  ]);
}
const u1 = /* @__PURE__ */ p(s1, [["render", l1], ["__scopeId", "data-v-8ac18265"]]);
const d1 = {
  name: "UniversityHeader",
  components: {
    UniversityHeaderButtonContainer: J0,
    UniversityHeaderButton: c1,
    UMNWordmark: u1
  },
  props: {},
  setup() {
  }
}, J = (t) => (x("data-v-1a02e5de"), t = t(), z(), t), M1 = { class: "outer-block" }, L1 = { class: "header-block" }, _1 = { class: "header-block-inner" }, h1 = { class: "branding-block" }, p1 = { class: "header-block-inner" }, g1 = { class: "link-block" }, v1 = /* @__PURE__ */ J(() => /* @__PURE__ */ e("span", { class: "header-button-contents" }, [
  /* @__PURE__ */ T(" MyU "),
  /* @__PURE__ */ e("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512"
  }, [
    /* @__PURE__ */ e("path", { d: "M80 192V144C80 64.47 144.5 0 224 0C303.5 0 368 64.47 368 144V192H384C419.3 192 448 220.7 448 256V448C448 483.3 419.3 512 384 512H64C28.65 512 0 483.3 0 448V256C0 220.7 28.65 192 64 192H80zM144 192H304V144C304 99.82 268.2 64 224 64C179.8 64 144 99.82 144 144V192z" })
  ])
], -1)), j1 = /* @__PURE__ */ J(() => /* @__PURE__ */ e("span", { class: "header-button-contents" }, [
  /* @__PURE__ */ e("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, [
    /* @__PURE__ */ e("path", { d: "M500.3 443.7l-119.7-119.7c27.22-40.41 40.65-90.9 33.46-144.7C401.8 87.79 326.8 13.32 235.2 1.723C99.01-15.51-15.51 99.01 1.724 235.2c11.6 91.64 86.08 166.7 177.6 178.9c53.8 7.189 104.3-6.236 144.7-33.46l119.7 119.7c15.62 15.62 40.95 15.62 56.57 0C515.9 484.7 515.9 459.3 500.3 443.7zM79.1 208c0-70.58 57.42-128 128-128s128 57.42 128 128c0 70.58-57.42 128-128 128S79.1 278.6 79.1 208z" })
  ]),
  /* @__PURE__ */ T(" Search ")
], -1));
function w1(t, a, c, s, n, i) {
  const u = O("UMNWordmark"), o = O("UniversityHeaderButton"), r = O("UniversityHeaderButtonContainer");
  return M(), L("div", M1, [
    e("div", L1, [
      e("div", _1, [
        e("div", h1, [
          _(u)
        ])
      ]),
      e("div", p1, [
        e("div", g1, [
          _(r, null, {
            default: w(() => [
              _(o, {
                linkTarget: "http://myu.umn.edu",
                showBorder: !1
              }, {
                default: w(() => [
                  v1
                ]),
                _: 1
              }),
              _(o, {
                linkTarget: "http://onestop.umn.edu",
                showBorder: !1
              }, {
                default: w(() => [
                  T("OneStop")
                ]),
                _: 1
              }),
              _(o, {
                linkTarget: "http://search.umn.edu",
                showBorder: !1
              }, {
                default: w(() => [
                  j1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]);
}
const y1 = /* @__PURE__ */ p(d1, [["render", w1], ["__scopeId", "data-v-1a02e5de"]]), I1 = (t) => (x("data-v-9c074f39"), t = t(), z(), t), N1 = {
  class: /* @__PURE__ */ y("umn-navbar tw-w-full tw-bg-umn-neutral-100")
}, f1 = { class: "mobile-nav__list tw-m-4 tw-flex tw-flex-col tw-gap-2 tw-p-0" }, m1 = /* @__PURE__ */ I1(() => /* @__PURE__ */ e("h2", { class: "tw-sr-only" }, "App Navigation", -1)), C1 = { class: "tw-flex tw-justify-between tw-flex-wrap" }, A1 = { class: "navbar-links-container tw-flex tw-m-0 tw-p-0 tw-items-center tw-flex-wrap" }, T1 = { class: "navbar-links-right-container tw-flex tw-m-0 tw-p-0 tw-items-center" }, S1 = /* @__PURE__ */ f({
  __name: "Navbar",
  props: {
    isOpen: { type: Boolean, default: !1 }
  },
  setup(t) {
    const { atBreakpoint: a } = H("always"), c = Y(D, a);
    return (s, n) => (M(), L("div", N1, [
      _(W, {
        enterFromClass: "tw-max-h-0",
        enterActiveClass: "tw-transition-all tw-ease-in",
        enterToClass: "tw-max-h-fit",
        leaveActiveClass: "tw-transition-all tw-ease-out",
        leaveFromClass: "tw-max-h-fit",
        leaveToClass: "tw-max-h-0"
      }, {
        default: w(() => [
          s.isOpen ? (M(), L("div", {
            key: 0,
            class: y(["mobile-nav-container inset-shadow tw-flex tw-w-full tw-flex-col tw-overflow-hidden tw-bg-white", {
              "tw-hidden": g(c)
            }])
          }, [
            e("ul", f1, [
              h(s.$slots, "navbar-links"),
              h(s.$slots, "navbar-links-right")
            ])
          ], 2)) : P("", !0)
        ]),
        _: 3
      }),
      e("nav", {
        role: "navigation",
        class: y(["tw-mx-auto tw-w-full tw-max-w-[90em]", [g(c) ? "tw-block" : "tw-hidden"]])
      }, [
        m1,
        e("div", C1, [
          e("ul", A1, [
            h(s.$slots, "navbar-links")
          ]),
          e("ul", T1, [
            h(s.$slots, "navbar-links-right")
          ])
        ])
      ], 2)
    ]));
  }
});
const x1 = /* @__PURE__ */ p(S1, [["__scopeId", "data-v-9c074f39"]]), z1 = {}, k1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "tw-w-4 tw-h-4"
}, D1 = /* @__PURE__ */ e("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M19.5 8.25l-7.5 7.5-7.5-7.5"
}, null, -1), b1 = [
  D1
];
function O1(t, a) {
  return M(), L("svg", k1, b1);
}
const E1 = /* @__PURE__ */ p(z1, [["render", O1]]), $1 = {}, U1 = {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "bars",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512",
  class: "tw-w-5 tw-h-5"
}, Y1 = /* @__PURE__ */ e("path", {
  fill: "currentColor",
  d: "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
}, null, -1), Q1 = [
  Y1
];
function H1(t, a) {
  return M(), L("svg", U1, Q1);
}
const V1 = /* @__PURE__ */ p($1, [["render", H1]]), B1 = ["aria-pressed", "aria-expanded"], W1 = /* @__PURE__ */ e("span", { class: "tw-uppercase tw-text-xs tw-font-semibold" }, "Menu", -1), P1 = /* @__PURE__ */ f({
  __name: "MenuButton",
  props: {
    isOpen: { type: Boolean }
  },
  setup(t) {
    return (a, c) => (M(), L("button", {
      "aria-pressed": a.isOpen,
      "aria-expanded": a.isOpen,
      title: "Toggle Section Menu Visibility",
      class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-1 tw-p-2 tw-text-umn-neutral-700 tw-border-0 tw-bg-transparent hover:tw-text-umn-neutral-900 tw-transition-colors"
    }, [
      W1,
      _(g(V1))
    ], 8, B1));
  }
}), R1 = { class: "header-row" }, G1 = { class: "header-row" }, F1 = { class: "header-row" }, Z1 = /* @__PURE__ */ f({
  __name: "AppHeader",
  props: {
    menuBreakpoint: { default: "md" }
  },
  setup(t) {
    const a = t, c = X(G), s = S(
      // .greaterOrEqual returns a ref
      // while .isGreaterOrEqual return the raw boolean
      // to ensure the value is recomputed when the window changes size
      // use the .greaterOrEqual ref
      () => c.greaterOrEqual(a.menuBreakpoint).value
    ), n = m(!1);
    B(
      s,
      () => {
        n.value = !1;
      },
      { immediate: !0 }
    ), s0(D, s);
    function i() {
      n.value = !n.value;
    }
    return (u, o) => (M(), L("div", {
      class: y(["masthead umn-app-header", {
        "umn-app-header--at-breakpoint": s.value
      }])
    }, [
      e("div", R1, [
        _(y1, { class: "header-row-internal" })
      ]),
      e("div", G1, [
        _(W0, {
          class: "header-row-internal header-separator",
          isMenuOpen: n.value
        }, {
          "app-link": w(() => [
            h(u.$slots, "app-link", {}, void 0, !0)
          ]),
          right: w(() => [
            e("div", {
              class: y(["menu-button-container", {
                "tw-hidden": s.value
              }])
            }, [
              _(P1, {
                isOpen: n.value,
                onClick: i
              }, null, 8, ["isOpen"])
            ], 2)
          ]),
          _: 3
        }, 8, ["isMenuOpen"])
      ]),
      e("div", F1, [
        _(x1, {
          isOpen: n.value,
          ref: "navbarRef"
        }, {
          "navbar-links": w(() => [
            h(u.$slots, "navbar-links", {}, void 0, !0)
          ]),
          "navbar-links-right": w(() => [
            h(u.$slots, "navbar-links-right", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["isOpen"])
      ])
    ], 2));
  }
});
const ot = /* @__PURE__ */ p(Z1, [["__scopeId", "data-v-e9e99b28"]]), X1 = /* @__PURE__ */ f({
  __name: "NavbarItem",
  props: {
    isActive: { type: Boolean, default: !1 }
  },
  setup(t) {
    return (a, c) => (M(), L("li", {
      class: y(["navbar-item tw-flex-1 tw-list-none tw-m-0 tw-transition-colors tw-relative hover:tw-bg-umn-neutral-200 tw-bg-umn-neutral-100", {
        "tw-bg-neutral-300 tw-font-bold tw-text-neutral-800": a.isActive
      }])
    }, [
      h(a.$slots, "default")
    ], 2));
  }
});
const J1 = /* @__PURE__ */ p(X1, [["__scopeId", "data-v-10ceb888"]]), q1 = /* @__PURE__ */ f({
  __name: "NavbarDropdown",
  props: {
    label: {}
  },
  setup(t) {
    const a = m(!1), c = m(null), { atBreakpoint: s } = H("always"), n = Y(D, s);
    return E0(c, () => {
      !c.value || !a.value || (a.value = !1);
    }), (i, u) => (M(), n0(J1, {
      ref_key: "itemContainer",
      ref: c,
      class: "navbar-dropdown"
    }, {
      default: w(() => [
        e("button", {
          onClick: u[0] || (u[0] = (o) => a.value = !a.value),
          class: y(["navbar-dropdown__button tw-flex tw-w-full tw-h-full tw-px-5 tw-items-center tw-gap-2 tw-whitespace-nowrap tw-justify-between tw-border-0 tw-text-base hover:tw-bg-umn-neutral-200", {
            "navbar-dropdown__button--is-open tw-text-umn-maroon tw-bg-neutral-200": a.value,
            "tw-bg-neutral-50": a.value && g(n),
            "tw-text-umn-neutral-700": !a.value
          }]),
          tabindex: "0"
        }, [
          e("span", null, $(i.label), 1),
          _(E1, {
            class: y(["tw-transition-transform chevron-down-icon", {
              "tw-transform tw-rotate-180": a.value,
              "tw-rotate-0": a.value && g(n),
              "tw-transform tw-rotate-0": !a.value
            }])
          }, null, 8, ["class"])
        ], 2),
        _(W, {
          enterFromClass: `tw-scale-y-95 ${g(n) ? "tw-max-h-fit" : "tw-max-h-0"} tw-opacity-0`,
          enterActiveClass: "tw-transition-all tw-ease-in",
          enterToClass: `tw-scale-y-100 tw-opacity-100 ${g(n) ? "tw-max-h-fit" : "tw-max-h-64"}`,
          leaveFromClass: `w-scale-y-100 tw-opacity-100 ${g(n) ? "tw-max-h-fit" : "tw-max-h-64"}`,
          leaveActiveClass: "tw-transition-all tw-ease-out",
          leaveToClass: `tw-scale-y-95 tw-opacity-0 ${g(n) ? "tw-max-h-fit" : "tw-max-h-0"}`
        }, {
          default: w(() => [
            a.value ? (M(), L("ul", {
              key: 0,
              class: y(["tw-bg-neutral-100 tw-overflow-hidden tw-origin-top tw-z-40 tw-p-0", {
                "tw-bg-neutral-50 tw-absolute tw-top-full tw-right-0 tw-w-48 tw--mt-1 tw-shadow-md tw-rounded-md": g(n)
              }])
            }, [
              h(i.$slots, "default")
            ], 2)) : P("", !0)
          ]),
          _: 3
        }, 8, ["enterFromClass", "enterToClass", "leaveFromClass", "leaveToClass"])
      ]),
      _: 3
    }, 512));
  }
});
const it = /* @__PURE__ */ p(q1, [["__scopeId", "data-v-fb0697cf"]]);
const K1 = {
  name: "PostIt",
  components: {},
  props: {},
  setup() {
  }
}, tt = { class: "flex-container" }, et = { class: "outer-container" }, at = { class: "inner-container" };
function ct(t, a, c, s, n, i) {
  return M(), L("div", tt, [
    e("div", et, [
      e("div", at, [
        h(t.$slots, "default", {}, void 0, !0)
      ])
    ])
  ]);
}
const rt = /* @__PURE__ */ p(K1, [["render", ct], ["__scopeId", "data-v-e2b01c66"]]);
export {
  nt as AppFooter,
  ot as AppHeader,
  R as CLAWordmark,
  W0 as CollegeHeader,
  x1 as Navbar,
  it as NavbarDropdown,
  J1 as NavbarItem,
  rt as PostIt,
  u1 as UMNWordmark,
  y1 as UniversityHeader
};
//# sourceMappingURL=index.js.map
